import React from "react";
import { useQzTrayPrint } from "../../../hooks/qztray/useQzTrayPrint";
import FormModal from "../FormModal";
import TicketRightPanel from "./TicketRightPanel";

/**
 * 🖨️ PrintTicketModalDesignPreview (sin vista previa)
 *
 * Ahora el modal solo muestra:
 * - Panel derecho: Información + controles de impresión
 *
 * 🔒 El modal no puede cerrarse manualmente. Solo desde el botón "Cancelar".
 */
const PrintTicketModalDesignPreview: React.FC = () => {
  const { showModal } = useQzTrayPrint();

  return (
    <FormModal
      isOpen={showModal}
      title="Impresión del ticket"
      maxWidth="max-w-md"
      overlayBg="dark"
      zIndex="top"
    >
      {/* Contenedor principal */}
      <div className="flex items-center justify-center px-3 md:px-5 pb-2">
        <TicketRightPanel />
      </div>
    </FormModal>
  );
};

export default PrintTicketModalDesignPreview;
